<div class="form-check puggles-form-check d-flex align-items-center gap-6">
    <input type="checkbox"
        id="{{ id() }}Check"
        class="form-check-input puggles-form-check-input"
        [checked]="checked()"
        [disabled]="disabled()"
        (change)="checkChanged.emit(!checked())">
    <label class="form-check-label puggles-form-check-label" for="{{ id() }}Check">{{ label() }}</label>
</div>
